import type { Ref } from 'vue'
import type { AuctionCarPagination } from '../../types/Car'
import { computed, unref } from 'vue'
import { useIsMobile } from '../useIsMobile'
import { useCarPageInfo } from './useCarPageInfo'
import { useGetCarLink } from './useGetCarLink'

export function useCarPaginationLinks(pagination: Ref<AuctionCarPagination | undefined>) {
  const isMobile = useIsMobile()
  const { pageType } = useCarPageInfo()
  const linkType = computed(() => {
    if (pageType.value === 'details')
      return 'details'

    return 'barometer'
  })

  const { getLink } = useGetCarLink()

  const prevLink = computed(() => {
    const link = getLink(unref(pagination)?.previous, linkType.value)

    if (!link)
      return

    return [
      link,
      '?pageType=prev',
      isMobile.value && linkType.value === 'barometer' ? '#content' : '',
    ].join('')
  })

  const nextLink = computed(() => {
    const link = getLink(unref(pagination)?.next, linkType.value)

    if (!link)
      return

    return [
      link,
      '?pageType=next',
      isMobile.value && linkType.value === 'barometer' ? '#content' : '',
    ].join('')
  })

  return {
    pagination,
    nextLink,
    prevLink,
  }
}
